import { Box, Button, Stack, Typography } from "@mui/material";
import { actionFilterTabs } from "../../utils/actionFilterUtils";

const toneByKey = {
  ALL: "#6c5ce7",
  OVERDUE: "#991b1b",
  DELIVERY_RISK: "#ef4444",
  PLAN_REVIEW: "#f59e0b",
  CHANGE_REVIEW: "#8b5cf6",
};

export const OssActionFilterTabs = ({ value, counts = {}, onChange }) => (
  <Stack
    direction="row"
    spacing={0.7}
    sx={{
      flexWrap: "nowrap",
      overflowX: "auto",
      overflowY: "hidden",
      scrollbarWidth: "thin",
      pb: 0.2,
      maxWidth: "100%",
    }}
  >
    {actionFilterTabs.map((tab) => {
      const active = value === tab.key;
      const tone = toneByKey[tab.key] || "#6c5ce7";

      return (
        <Button
          key={tab.key}
          variant={active ? "contained" : "outlined"}
          onClick={() => onChange(tab.key)}
          sx={{
            minHeight: 34,
            px: 1.15,
            flexShrink: 0,
            borderColor: active ? tone : "#e5e7eb",
            bgcolor: active ? tone : "#fff",
            color: active ? "#fff" : "#475569",
            "&:hover": {
              borderColor: tone,
              bgcolor: active ? tone : `${tone}0f`,
            },
          }}
        >
          <Stack direction="row" spacing={0.6} alignItems="center">
            <span>{tab.label}</span>
            <Box
              component="span"
              sx={{
                px: 0.65,
                py: 0.1,
                minWidth: 24,
                borderRadius: 999,
                bgcolor: active ? "rgba(255,255,255,0.18)" : "#f1f5f9",
              }}
            >
              <Typography component="span" sx={{ fontSize: 12, fontWeight: 800, lineHeight: 1 }}>
                {Number(counts[tab.key] || 0).toLocaleString()}
              </Typography>
            </Box>
          </Stack>
        </Button>
      );
    })}
  </Stack>
);
